import { ColliClient, ColliContentClient } from '@frontend/colli/api';
import { CreateColli, CreateColliContent } from '@frontend/colli/types';
import { ExtendedTransaction } from '@frontend/transaction/types';
import { MobileWizardStateData } from '@frontend/wizard/mobile';

interface Location {
    spotId: string;
    moduleId: string | null;
    slotId: string | null;
}

/** Creates the order's pre-seeded colli and content after its local transaction has been synchronized. */
export async function syncOrderTransactionCollis(
    data: MobileWizardStateData,
    transaction: ExtendedTransaction,
    location: Location
): Promise<void> {
    if (!data.orderTransaction || data.orderTransactionCollisCreated) return;

    const collis = (data.collis ?? []) as CreateColli[];
    const contents = (data.orderTransactionColliContents ?? []) as CreateColliContent[];

    for (const [index, colli] of collis.entries()) {
        const createdColli = await ColliClient.postColli(transaction.account_id, transaction.id, {
            ...colli,
            spot_id: location.spotId,
            module_id: location.moduleId,
            slot_id: location.slotId
        });

        const content = contents[index];
        if (content) {
            await ColliContentClient.postColliContent(transaction.account_id, transaction.id, createdColli.id, content);
        }
    }
}
